import React, {ReactNode, useState} from 'react';

import styled from 'styled-components';

import {HeadingText} from 'app/components/general/HeadingText';

import type {AssigneesByType} from '../types';

export type AssignedItemsType = {[id: string]: AssigneesByType};

interface Props {
  children: (opts: {
    assigning: string | null;
    setAssigning: (assigning: null | string) => unknown;
    ListHeading: typeof ListHeading;
  }) => ReactNode;
}

export function AssignFormAssignToListStructure({children}: Props) {
  // step or lane ID being assigned (currently showing select components)
  const [assigning, setAssigning] = useState<null | string>(null);

  return (
    <StyledAssignableListDiv className="list-group">
      {children({ListHeading, assigning, setAssigning})}
    </StyledAssignableListDiv>
  );
}

function ListHeading({children}: {children: ReactNode}): JSX.Element {
  return (
    <div className="heading list-group-item px-3 py-1">
      <HeadingText>{children}</HeadingText>
    </div>
  );
}

const StyledAssignableListDiv = styled.div`
  .heading {
    border-top: none;
    border-bottom-width: 2px;
    background-color: #f6f6f6;
  }

  .list-group-item {
    border-left: none;
    border-right: none;
  }
`;
